import { render, staticRenderFns } from "./customHomePage.vue?vue&type=template&id=fb131654&scoped=true"
import script from "./customHomePage.vue?vue&type=script&lang=js"
export * from "./customHomePage.vue?vue&type=script&lang=js"
import style0 from "./customHomePage.vue?vue&type=style&index=0&id=fb131654&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb131654",
  null
  
)

export default component.exports